// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//local
//const baseUrl ='https://incanet/portaladministrativo/sghi.pamodsisaapi';
// => const baseUrl ='http://incanetdev/PortalAdministrativo/SGHI.PaModSISAApiDev';
////const baseUrl ='http://incanet/PortalAdministrativo/SGHI.PaModSISA/backeditais';
//const baseUrl ='http://incanet/PortalAdministrativo/SGHI.PaModSISA/BackEditaisNew';
/////   --> const baseUrl ='http://incanet/PortalAdministrativo/SGHI.PaModSISAapi';
const baseUrl ='https://app.inca.gov.br/PortalAdministrativo/SGHI.PaModSISAapi';
//const baseUrl ='https://app.inca.gov.br/PortalAdministrativo/SGHI.PaModSISA/BackEditaisNew';
/// => const baseUrl ='http://incanet/PortalAdministrativo/SGHI.PaModSISA/BackEditaisNew';
//const baseUrlDocs ='http://incanet/PortalAdministrativo/SGHI.PaModSISAApi';
///////// ==> const baseUrl ='http://localhost:5401';

export const environment = {

  production: false,
  bancoDocumentos : `${baseUrl}/documentos/teste`,
  bancoCurso : `${baseUrl}/Api/v1/Curso`,
  bancoGestor : `${baseUrl}/Api/v1/Gestor`,
  bancoEdital : `${baseUrl}/Api/v1/Edital`,  // `https://app.inca.gov.br/PortalAdministrativo/SGHI.PaModSISA/BackEditaisNew/Api/v1/Edital`
  bancoInscrito : `${baseUrl}/Api/v1/Inscricao`,
  bancoInstituicao : `${baseUrl}/Api/v1/Instituicao`,
  bancoConselho : `${baseUrl}/Api/v1/Conselho`,
  bancoUf : `${baseUrl}/Api/v1/Uf`,
  bancoUpload : `${baseUrl}/Api/v1/Upload`,
  bancoEndereco : "http://incanetdev/portalassistencia/sghiapidev/api/Localidade",
  caminhoLogoInca : "https://app.inca.gov.br/PortalAdministrativo/SGHI.PaModSISA/EDITAL", //"http://incanetdev/PortalAssistencia/SITAM.Protocolo/img/logo-inca.png",
  caminhoArquivosUpload : `${baseUrl}/Documentos/Editais/`, //"./documentos",

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
